// extracted by mini-css-extract-plugin
module.exports = {"hire-team__wrapper":"style_hire-team__wrapper__e9pLT","button--mainHeader":"style_button--mainHeader__Kiliz"};